import CryptoJS from "crypto-js";

const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPT_KEY; // Use a secure key (ideally store this in env variables, not hardcoded)

export function encryptData(plainText, key = ENCRYPTION_KEY) {
  const encrypted = CryptoJS.AES.encrypt(
    encodeURIComponent(plainText),
    key
  ).toString();
  return encrypted;
}

export function decryptData(cipherText, key = ENCRYPTION_KEY) {
  const bytes = CryptoJS.AES.decrypt(cipherText, key);
  const decrypted = decodeURIComponent(bytes.toString(CryptoJS.enc.Utf8));
  return decrypted;
}
